// extracted by mini-css-extract-plugin
export default {"container":"BlockAnimation_container__ysKOU"};